import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import submitIcon from 'shared/assets/images/submit_icon.png';
import { carPriceBySlug } from 'shared/helpers/transportInfo';
import currencies from 'shared/constants/json/currency.json';
import editIcon from 'shared/assets/images/edit_icon.png';
import clearIcon from 'shared/assets/images/clear_icon.png';
import { withFetch } from 'shared/hocs/withFetch';
import API from 'shared/constants/api';
import Button from './PriceButton/PriceButton';
import s from './Price.css';

const UAH_CURRENCY = currencies.find(currency => currency.slug === 'uah');
const USD_CURRENCY = currencies.find(currency => currency.slug === 'usd');
const EUR_CURRENCY = currencies.find(currency => currency.slug === 'eur');

class Price extends React.Component {
  static propTypes = {
    shouldEmphasizePrice: PropTypes.bool.isRequired,
    isNegotiablePrice: PropTypes.bool,
    isSparepart: PropTypes.bool,
    isProfile: PropTypes.bool,
    isEuro: PropTypes.bool,
    setRatioImage: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    isTop: PropTypes.bool.isRequired,
    price: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    fetch: PropTypes.func.isRequired,
    intl: PropTypes.shape().isRequired,
    advertID: PropTypes.number.isRequired,
    children: PropTypes.node,
    //
  };
  static defaultProps = {
    isProfile: false,
    isEuro: false,
    isSparepart: false,
    isNegotiablePrice: false,
    transportSlug: null,
    children: null,
  };

  state = {
    isUkEdit: false,
    isUsdEdit: false,
    localPrice: undefined,
    savedOnServerPrice: undefined,
  };

  getExchangeRate = (price, currency) => price.find(item => item.currency === currency.slug).value;

  setInputPrice = (inputValue, currency) => {
    const { price } = this.props;
    const isUsdCurrent = price.find(data => data.exchange_rate === 1 && data.currency === 'usd');
    const isUsd = currency === 'usd';
    const ukExchangeRate = price.find(exchangeItem =>
      isUsdCurrent ? exchangeItem.currency === 'uah' : exchangeItem.currency === 'usd',
    ).exchange_rate;

    let priceResult = price.map(item => {
      if (isUsd) {
        if (item.currency === 'usd') return { ...item, value: inputValue };
        else if (item.currency === 'uah')
          return {
            ...item,
            value: isUsdCurrent ? inputValue * ukExchangeRate : inputValue / ukExchangeRate,
          };
      }
      if (item.currency === 'uah') return { ...item, value: inputValue };
      else if (item.currency === 'usd')
        return {
          ...item,
          value: isUsdCurrent ? inputValue / ukExchangeRate : inputValue * ukExchangeRate,
        };
    });
    priceResult = priceResult.filter(priceItem => priceItem);

    this.setState({ localPrice: priceResult });
  };

  handleClickEdit = fieldName => {
    this.setState({ [fieldName]: !this.state[fieldName] });
  };

  handleClearInput = () => {
    this.setState({
      isUkEdit: false,
      isUsdEdit: false,
      localPrice: undefined,
    });
  };

  handleSubmit = (priceEdited, currency) => {
    const { fetch, token, advertID, isSparepart } = this.props;
    const { localPrice } = this.state;

    const requestParams = {
      currency: currency.id,
      price: Math.round(this.getExchangeRate(priceEdited, currency)),
    };

    fetch(isSparepart ? API.SPARE_PARTS.ITEM(advertID) : API.ADVERT.ITEM(advertID), {
      method: 'PATCH',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestParams),
    })
      .then(response => {
        if (!response.ok) {
          response.json(); // for displaying request data in browser response
          throw new Error('Не удалось изменить цену. Попробуйте позже.');
        }
        return response;
      })
      .then(r => r.json())
      .then(() => {
        this.setState({
          isUkEdit: false,
          isUsdEdit: false,
          localPrice: undefined,
          savedOnServerPrice: localPrice,
        });
      });
  };

  render() {
    const {
      shouldEmphasizePrice,
      setRatioImage,
      isTop,
      price,
      isNegotiablePrice,
      isProfile,
      isEuro,
      intl,
    } = this.props;
    const { isUkEdit, isUsdEdit, localPrice, savedOnServerPrice } = this.state;
    const priceEdited = localPrice || savedOnServerPrice || price;

    return (
      <React.Fragment>
        {isNegotiablePrice ? (
          <div className={s.price}>
            <span
              className={cx(
                s.priceVal,
                { [s.topPrice]: isTop },
                { [s.emphasizePrice]: shouldEmphasizePrice },
              )}
            >
              {intl.formatMessage({ id: 'договорная' })}
            </span>
            <div />
          </div>
        ) : (
          <div className={s.price}>
            <div className={s.priceItem}>
              <div className={cx(s.priceValueBlock, { [s.marginRight]: isUsdEdit })}>
                {isUkEdit ? (
                  <input
                    className={s.editInput}
                    type="number"
                    value={Math.round(this.getExchangeRate(priceEdited, UAH_CURRENCY))}
                    onChange={e => this.setInputPrice(+e.target.value, 'uah')}
                  />
                ) : (
                  <span
                    className={cx(
                      s.priceVal,
                      { [s.topPrice]: isTop },
                      { [s.emphasizePrice]: shouldEmphasizePrice },
                    )}
                  >
                    {carPriceBySlug(priceEdited, UAH_CURRENCY)}
                  </span>
                )}
              </div>
              {!isUsdEdit && !isUkEdit && isProfile && (
                <Button
                  handleClickEdit={() => this.handleClickEdit('isUkEdit')}
                  setRatioImage={setRatioImage}
                  icon={editIcon}
                  width={27}
                />
              )}
              {!isUsdEdit && isUkEdit && isProfile && (
                <React.Fragment>
                  <Button
                    handleClickEdit={() => this.handleSubmit(priceEdited, UAH_CURRENCY)}
                    setRatioImage={setRatioImage}
                    icon={submitIcon}
                    width={21}
                    isSubmit
                  />
                  <Button
                    handleClickEdit={this.handleClearInput}
                    setRatioImage={setRatioImage}
                    icon={clearIcon}
                    width={21}
                    isSubmit
                  />
                </React.Fragment>
              )}
            </div>
            <div className={s.priceItem}>
              <div className={cx(s.priceValueBlock, { [s.marginRight]: isUkEdit })}>
                {isUsdEdit ? (
                  <input
                    className={s.editInput}
                    type="number"
                    value={Math.round(this.getExchangeRate(priceEdited, USD_CURRENCY))}
                    onChange={e => this.setInputPrice(+e.target.value, 'usd')}
                  />
                ) : (
                  <span className={cx(s.priceVal, s.secondaryPrice, { [s.topPrice]: isTop })}>
                    {carPriceBySlug(priceEdited, isEuro ? EUR_CURRENCY : USD_CURRENCY)}
                  </span>
                )}
              </div>
              {!isUkEdit && !isUsdEdit && isProfile && (
                <Button
                  handleClickEdit={() => this.handleClickEdit('isUsdEdit')}
                  setRatioImage={setRatioImage}
                  icon={editIcon}
                  width={27}
                />
              )}

              {isUsdEdit && !isUkEdit && isProfile && (
                <React.Fragment>
                  <Button
                    handleClickEdit={() => this.handleSubmit(priceEdited, USD_CURRENCY)}
                    setRatioImage={setRatioImage}
                    icon={submitIcon}
                    width={21}
                    isSubmit
                  />
                  <Button
                    handleClickEdit={this.handleClearInput}
                    setRatioImage={setRatioImage}
                    icon={clearIcon}
                    width={21}
                    isSubmit
                  />
                </React.Fragment>
              )}
            </div>
            {this.props.children}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(s)(withFetch(Price));



// WEBPACK FOOTER //
// ./src/desktop/components/PriceBlock/Price.js